module.exports = __webpack_public_path__ + "static/media/logo-part-3.b3ca01fd.svg";